<nav class="page-switch" aria-label="Contract pages">
  <a class="switch-tab" routerLink="/player-auction" [class.active]="current === 'sell'"
    [attr.aria-current]="current === 'sell' ? 'page' : null"
    [matTooltip]="sellActive ? sellActive + ' transferring' : ''">
    <mat-icon>receipt</mat-icon>
    <span class="tab-label">Orders</span>
    @if (sellActive) {
    <b class="tab-count">{{ sellActive }}</b>
    }
  </a>
  <a class="switch-tab" routerLink="/player-auction/buy-contract" [class.active]="current === 'buy'"
    [attr.aria-current]="current === 'buy' ? 'page' : null"
    [matTooltip]="buyActive ? buyActive + ' active' : ''">
    <mat-icon>shopping_cart</mat-icon>
    <span class="tab-label">Buy</span>
    @if (buyActive) {
    <b class="tab-count">{{ buyActive }}</b>
    }
  </a>
</nav>

<div class="refresh">
  <button mat-icon-button (click)="refresh.emit()" matTooltip="Refresh" [disabled]="refreshing">
    <mat-icon [class.spinning]="refreshing">refresh</mat-icon>
  </button>
  <span class="last-update-text">
    @if (refreshing) { … } @else { <span class="lu-prefix">Updated </span>{{ lastUpdate }}s<span class="lu-suffix"> ago</span> }
  </span>
</div>
